/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Unarchiveconfirmbtn2Inputs */



/**
* | output |
* | --- |
* | "Bring back" |
*
* @param {Unarchiveconfirmbtn2Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const unarchiveconfirmbtn2 = /** @type {((inputs?: Unarchiveconfirmbtn2Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Unarchiveconfirmbtn2Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Bring back")
	if (locale === "es") return /** @type {LocalizedString} */ ("Devolver")
	return /** @type {LocalizedString} */ ("Вернуть")
});
export { unarchiveconfirmbtn2 as "unarchiveConfirmBtn" }